export default __webpack_public_path__ + "static/404-ghost-2ff0fed8dd5c681c9e445ca71d2df3a3.jpg";